import React from 'react'
import VisibleComponent from '../../shared/VisibleComponent'

const TarifResa = () => {
  return (
    <VisibleComponent>
      <div id="tarifs-reservation" className="elements-group centre">
        <h2>Tarifs & réservation </h2>
        <p>
          Tous les événements du festival sont soit gratuits soit à prix libre
          (voir dans le programme ci-dessus pour le détail).
        </p>
        <p>
          Réservation obligatoire pour :
          <ul>
            <li>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLScRFp2nRnMtmpaTPWTQmfuxVoHTHUyUc24PW-DT7_fbyldTAw/viewform">
                l'atelier danse du mardi
              </a>
            </li>

            <li>
              <a href="https://www.helloasso.com/associations/lieu-topie/evenements/atelier-cuisine-palestinienne">
                l'atelier cuisine
              </a>
            </li>

            <li>
              <a href="https://www.helloasso.com/associations/les-brayauds/evenements/esperlueta-5">
                le stage de danses du samedi
              </a>
            </li>
          </ul>
        </p>
        <p>
          Réservation conseillée pour :
          <ul>
            <li>
              <a href="https://www.helloasso.com/associations/les-brayauds/evenements/esperlueta-5">
                le bal du samedi
              </a>
            </li>
          </ul>
        </p>
        <p>Tous les autres événements sont en accès libre.</p>
        {/* <p>Pass 1 soir : 6€ tarif réduit / 12€ plein tarif</p>
        <p>Pass 2 soirs : 10€ tarif réduit / 20€ plein tarif</p> */}
        {/* <p>
          Tarif réduit : étudiants, demandeurs d'emploi, RSA, réseau associatif,
          moins de 18 ans
        </p> */}
        {/* <p>Les inscriptions ne sont pas encore ouvertes, revenez bientôt !</p> */}
        {/* Les réservations et inscriptions aux stages sont closes, une billetterie sera ouverte sur place. */}
      </div>
    </VisibleComponent>
  )
}

export default TarifResa
